<template>
  <modal-frame
    :submit="submit"
    :shape-width="600"
    :shape-height="250"
    :disable-cancel-button="true"
    class="modal-frame"
  >
    <div class="title-wrapper">
      <span class="title">계정 비활성화</span>
    </div>

    <div class="contents-wrapper">
      <span class="contents-text">{{ param.email }} 계정을 비활성화 하시겠습니까?</span>
    </div>
  </modal-frame>
</template>

<script>
import ModalFrame from "../ModalFrame";

export default {
  name: "ModalDeleteUser",
  components: {
    ModalFrame
  },
  props: {
    param: Object
  },
  methods: {
    async submit() {
      let message = "";

      try {
        await this.$store.dispatch("deleteUser", { id: this.param.id });
        message = `${this.param.email} 계정을 비활성화 하였습니다..`;
      } catch (err) {
        message = "문제가 있어 설정 변경을 하지 못했습니다.";
      }

      this.$modal.clearComponent();
      this.$toast(message);
      this.$table.updateField();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-frame {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  .title-wrapper {
    display: flex;
    justify-content: flex-start;
    padding: 24px 32px;

    .title {
      color: rgb(55, 168, 175);
      font-size: 22px;
    }
  }

  .contents-wrapper {
    display: flex;
    padding: 0 32px;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;

    margin-top: 30px;
    margin-bottom: 30px;

    .contents {
      display: flex;
      flex-direction: row;
      padding-left: 15px;
      width: 100%;

      .contents-text {
        flex: 2;
        font-size: 22px;
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalDeleteUser.vue